import React, { Fragment, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import i18n from 'i18n/config';
import { changeLanguage } from 'i18next';

const LanguageBasedRoute = () => {
  const { lang } = useSelector((state) => state.language);

  useEffect(() => {
    changeLanguage(lang);
    document.dir = i18n.dir();
  }, []);

  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};

export default LanguageBasedRoute;
